import React from "react";

export const Clock = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Map = ({ className }) => {
    return (
      <svg
        className={`${className}`}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 5.7637C14.6897 5.7637 14.3836 5.69149 14.106 5.55277L9.894 3.44677C9.6164 3.30805 9.31033 3.23584 9 3.23584M15 5.7637C15.3103 5.7637 15.6164 5.69149 15.894 5.55277L19.553 3.72277C19.7056 3.64653 19.8751 3.61058 20.0455 3.61834C20.2159 3.6261 20.3814 3.67731 20.5265 3.7671C20.6715 3.8569 20.7911 3.98229 20.874 4.13135C20.9569 4.28042 21.0003 4.44821 21 4.61877V17.3828C20.9999 17.5684 20.9481 17.7504 20.8505 17.9083C20.7528 18.0662 20.6131 18.1938 20.447 18.2768L15.894 20.5538C15.6164 20.6925 15.3103 20.7647 15 20.7647M15 5.7637V20.7647M15 20.7647C14.6897 20.7647 14.3836 20.6925 14.106 20.5538L9.894 18.4478C9.6164 18.3091 9.31033 18.2368 9 18.2368C8.68967 18.2368 8.3836 18.3091 8.106 18.4478L4.447 20.2778C4.29436 20.3541 4.12473 20.39 3.95426 20.3822C3.78379 20.3744 3.61816 20.3231 3.47312 20.2332C3.32808 20.1433 3.20846 20.0177 3.12565 19.8685C3.04284 19.7193 2.99958 19.5514 3 19.3808V6.61777C3.0001 6.43211 3.05189 6.25014 3.14956 6.09225C3.24722 5.93435 3.38692 5.80676 3.553 5.72377L8.106 3.44677C8.3836 3.30805 8.68967 3.23584 9 3.23584M9 3.23584V18.2358"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    );
  };


  export const Phone1 = ({ className }) => {
    return (
      <svg
        className={`${className}`}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 16.9201V19.9201C22.0011 20.1986 21.9441 20.4743 21.8325 20.7294C21.7209 20.9846 21.5573 21.2137 21.3521 21.402C21.1468 21.5902 20.9046 21.7336 20.6407 21.8228C20.3769 21.912 20.0974 21.9452 19.82 21.9201C16.7428 21.5857 13.787 20.5342 11.19 18.8501C8.77382 17.3148 6.72533 15.2663 5.18999 12.8501C3.49997 10.2413 2.44824 7.27109 2.11999 4.1801C2.095 3.90356 2.12787 3.62486 2.21649 3.36172C2.30512 3.09859 2.44756 2.85679 2.63476 2.65172C2.82196 2.44665 3.0498 2.28281 3.30379 2.17062C3.55777 2.05843 3.83233 2.00036 4.10999 2.0001H7.10999C7.5953 1.99532 8.06579 2.16718 8.43376 2.48363C8.80173 2.80008 9.04207 3.23954 9.10999 3.7201C9.23662 4.68016 9.47144 5.62282 9.80999 6.5301C9.94454 6.88802 9.97366 7.27701 9.8939 7.65098C9.81415 8.02494 9.62886 8.36821 9.35999 8.6401L8.08999 9.9101C9.51355 12.4136 11.5864 14.4865 14.09 15.9101L15.36 14.6401C15.6319 14.3712 15.9751 14.1859 16.3491 14.1062C16.7231 14.0264 17.1121 14.0556 17.47 14.1901C18.3773 14.5286 19.3199 14.7635 20.28 14.8901C20.7658 14.9586 21.2094 15.2033 21.5265 15.5776C21.8437 15.9519 22.0122 16.4297 22 16.9201Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    );
  };
  export const ChevronDown = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="#6C6C6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronUp = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 15L12 9L18 15"
        stroke="#6C6C6C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


